import { useBackend } from "../../services";

export const useGetDiscogsRequestToken = () => {
  const { get } = useBackend();
  return async () => {
    return await get("discogs/token");
  };
};
